"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheListItem = exports.RocheListItemInner = void 0;

require("core-js/modules/es.string.small.js");

var _react = _interopRequireDefault(require("react"));

var _clsx3 = _interopRequireDefault(require("clsx"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _utils = require("../utils");

var _list = require("./list.context");

var _listItem = require("./list-item.styles");

var _core = require("../core");

var _excluded = ["classes", "variant", "size", "button"],
    _excluded2 = ["gap", "selectedHighlight", "extraSmall", "small", "large", "extraLarge"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Important **
 * To be able to use props of such a Material-UI component on their own, props
 * should be used with type arguments. Otherwise, the component prop will not
 * be present in the props of the Material-UI component.
 * https://material-ui.com/guides/typescript/#usage-of-component-prop
 **/
var RocheListItemInner = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useListContext, _ref, _ref2, _clsx;

  var classes = props.classes,
      inputVariant = props.variant,
      inputSize = props.size,
      button = props.button,
      rest = _objectWithoutProperties(props, _excluded); // Determine variant & size based on prop input and context:


  var context = (_useListContext = (0, _list.useListContext)()) !== null && _useListContext !== void 0 ? _useListContext : {};
  var contextVariant = context.variant,
      contextSize = context.size;
  var variant = (_ref = inputVariant !== null && inputVariant !== void 0 ? inputVariant : contextVariant) !== null && _ref !== void 0 ? _ref : 'highlight';
  var size = (_ref2 = inputSize !== null && inputSize !== void 0 ? inputSize : contextSize) !== null && _ref2 !== void 0 ? _ref2 : 'medium'; // Extract non-MUI classes and merged classes:

  var _mergeClasses = (0, _utils.mergeClasses)((0, _listItem.useStyles)(), classes),
      gap = _mergeClasses.gap,
      selectedHighlight = _mergeClasses.selectedHighlight,
      extraSmall = _mergeClasses.extraSmall,
      small = _mergeClasses.small,
      large = _mergeClasses.large,
      extraLarge = _mergeClasses.extraLarge,
      innerClasses = _objectWithoutProperties(_mergeClasses, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], _extends({
    classes: _objectSpread(_objectSpread({}, innerClasses), {}, {
      root: (0, _clsx3["default"])(innerClasses.root, (_clsx = {}, _defineProperty(_clsx, gap, variant === 'gap'), _defineProperty(_clsx, extraSmall, size === 'extraSmall'), _defineProperty(_clsx, small, size === 'small'), _defineProperty(_clsx, large, size === 'large'), _defineProperty(_clsx, extraLarge, size === 'extraLarge'), _clsx)),
      selected: (0, _clsx3["default"])(innerClasses.selected, _defineProperty({}, selectedHighlight, variant === 'highlight'))
    }),
    button: button
    /*See Note 1*/
    ,
    ref: ref
  }, rest));
});

exports.RocheListItemInner = RocheListItemInner;
RocheListItemInner.displayName = (0, _core.rochePrefix)('ListItem');
RocheListItemInner.defaultProps = {
  button: true
};
var RocheListItem = RocheListItemInner;
exports.RocheListItem = RocheListItem;
var _default = RocheListItem;
/**
 * NOTE 1: button property is not well typed in MUI types.
 */

exports["default"] = _default;